import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { PrivateRoute } from 'components/inline/PrivateRoute';
import LazySpinner from 'components/layouts/LazySpinner';
import PublicLayout from 'components/layouts/Public';
import * as publicRoutes from 'components/layouts/Public/routes';

const CreditLimitConfirmation = lazy(
  () => import('components/pages/Account/CreditLimitConfirmation'),
);
const Login = lazy(() => import('components/pages/Login'));
const ResetPassword = lazy(
  () => import('components/pages/ResetPassword/ResetPassword'),
);

function PublicRouter(): JSX.Element {
  return (
    <Routes>
      <Route
        path={publicRoutes.login}
        element={
          <PublicLayout isLogin={true}>
            <Suspense fallback={<LazySpinner />}>
              <Login />
            </Suspense>
          </PublicLayout>
        }
      />
      <Route
        path={publicRoutes.resetPassword(':guid')}
        element={
          <Suspense fallback={<LazySpinner />}>
            <ResetPassword />
          </Suspense>
        }
      />
      <Route
        path={publicRoutes.creditLimitConfirm(':guid')}
        element={
          <Suspense fallback={<LazySpinner />}>
            <CreditLimitConfirmation />
          </Suspense>
        }
      />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <PublicRouter data-testid="App" />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default PublicRouter;
